import { createSlice } from '@reduxjs/toolkit';
import { getMarketplaceItemInventoryBuilder, generateInventoryFileBuilder } from './builder';

const initialState = {
  marketplaceItemInventory: [],
  generateInventoryFile: null,

  generateInventoryFilePending: false,
  getMarketplaceItemInventoryPending: false,
};

export const inventorySlice = createSlice({
  name: 'inventoryInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getMarketplaceItemInventoryBuilder(builder);
    generateInventoryFileBuilder(builder);

    builder.addCase('logout', () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = inventorySlice.actions;

export const selectMarketplaceItemInventory = state => state.inventoryInfo.marketplaceItemInventory;
export const selectGetMarketplaceItemInventoryPending = state => state.inventoryInfo.getMarketplaceItemInventoryPending;

export const selectGeneratedFile = state => state.inventoryInfo.generateInventoryFile;
export const selectSelectGenerateInventoryFilePending = state => state.inventoryInfo.generateInventoryFilePending;

export default inventorySlice.reducer;
